import { render } from "./ProdAvailabilityMonthView.vue?vue&type=template&id=00d08479&scoped=true"
import script from "./ProdAvailabilityMonthView.vue?vue&type=script&lang=js"
export * from "./ProdAvailabilityMonthView.vue?vue&type=script&lang=js"

import "./ProdAvailabilityMonthView.vue?vue&type=style&index=0&id=00d08479&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d08479"]])

export default __exports__